<script>
import store from '../store/index.js';
import {reduce} from 'lodash';
export default {
    data() {
		return { 
            list: store.carSeries.series.list,
            seriesEl: null
        }
    },
    computed: {
        isShowCoupon() {
             return store.isShowCoupon;
        },
        couponValue() {
            return store.couponValue;
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.addMointor();
        });
    },
    methods: {
        getEl() {
			if (this.seriesEl) {
				return this.seriesEl;
			}
			this.seriesEl = document.querySelector('#seriesWrap');
			return this.seriesEl;
        },
         // 切换到指定车系 并定位到上面
        toPosition(index) {
            this.changeSeries(index);

            let offsetTop = this.getEl().offsetTop;
            document.body.scrollTop = document.documentElement.scrollTop = parseInt(offsetTop, 10);
        },
        changeSeries(index) {
            this.$eventBus.$emit('changeSeries', index);
        },
        addMointor() {
            // 曝光
            this.$clickMonitor.update(reduce(document.querySelectorAll('.j-recommend'), (arr, el) => {
				const callback = function (params) {
					const buttonId = `recommend-${params.monitor.status}`;
					return {
						buttonId,
						...store.getClickMonitorParams()
					};
				};
				arr.push({el, event: 'expose', callback});
				return arr;
            }, []));
            
            // 点击
			this.$clickMonitor.update(reduce(document.querySelectorAll('.j-recommend-item'), (arr, el) => {
				const callback = function (params) {
					const index = params.options.el.getAttribute('data-index');
					const buttonId = `recommend-${+index + 1}-${params.monitor.status}`;
					return {
						buttonId,
						...store.getClickMonitorParams()
					};
				};
				arr.push({el, event: 'click', callback});
				return arr;
            }, []));
            
		}
    }
}
</script>
<template>
<div class="wrap">
    <h2 class="title">推荐车系</h2>
    <ul class="list-wrap j-recommend">
        <li class="item-list j-recommend-item" v-for="(item, index) in list" :key="item.id" @click="toPosition(index)" :data-index="index">
            <!-- <img src="../../assets/recommend-2.png" alt="" class="item-list-img" v-show="isShowCoupon"> -->
            <div class="imgbox">
                <img :src="item.image" alt="">
            </div>
            <div class="carinfo">
                <h4>{{item.name}}</h4>
                <p>{{item.policy}} <span v-if="isShowCoupon">送{{couponValue}}元打车券</span></p>
                <a href="javascript:;">免费获取底价</a>
            </div>
        </li>
    </ul>
</div>
</template>
<style lang="stylus" scoped>
.wrap 
    margin: 2rem .8rem 1rem .8rem;
    background:rgba(255,138,93,0.18);
    border-radius:0.53rem;
    border:0.05rem solid rgba(251,173,99,0.38);
    .title
        text-indent -999px
        margin 0 auto 0 auto
        width 10.67rem
        height 4.16rem
        background url("../../assets/title_tjcx_bg.png") no-repeat
        background-size 100%
        margin-top -2rem
    ul.list-wrap
        padding 0 0.53rem 0.8rem
        .item-list
            background-color #fff
            height 5.33rem
            margin-bottom 0.53rem
            display flex
            flex 1
            border-radius 0.21rem
            position relative
            .item-list-img
                position absolute
                top 0
                right 0
                height 2.88rem
            .imgbox
                background-color #F0F0F0
                width 8.48rem
                height 5.33rem
                text-align center
                border-radius 0.21rem 0rem 0rem 0.21rem
                img 
                    height 100%
                    border-radius 0.21rem 0rem 0rem 0.21rem
            .carinfo
                font-size .75rem
                padding-left 1.28rem
                padding-top 0.69rem
                font-family PingFangSC-Semibold,PingFang SC
                h4
                    font-size 0.75rem
                    color rgba(51,51,51,1)
                    font-weight 600
                p
                    font-size 0.64rem
                    font-family semibold
                    color #F76F1E
                    margin-bottom 0.5rem
                    margin-top 0.2rem
                    text-overflow ellipsis
                    overflow hidden
                    white-space nowrap
                    span
                        font-size .64rem
                a
                    width 6.53rem
                    height 1.49rem
                    line-height 1.49rem
                    display inline-block
                    color #ffffff
                    font-size 0.69rem
                    font-weight 600
                    text-align center
                    background linear-gradient(144deg,rgba(250,217,97,1) 0%,rgba(247,107,28,1) 100%)
                    border-radius 0.75rem
                    text-decoration none
        .item-list:last-child
            margin-bottom 0

            
    
</style>